import { getUtilityClasses } from "../styles";
export const menuButtonTooltipClasses = getUtilityClasses("MenuButtonTooltip", [
    "titleContainer",
    "label",
    "shortcutKey",
    "contentWrapper",
]);
